import { render, staticRenderFns } from "./studio.vue?vue&type=template&id=4ddcf7f9&scoped=true&"
import script from "./studio.vue?vue&type=script&lang=js&"
export * from "./studio.vue?vue&type=script&lang=js&"
import style0 from "./studio.vue?vue&type=style&index=0&id=4ddcf7f9&lang=scss&scoped=true&"
import style1 from "./studio.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddcf7f9",
  null
  
)

export default component.exports